import React from 'react'
import Svg from './Svg'
export const SvgEyeWithLine = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M22.185 1.536a1.196 1.196 0 00-1.693 0L1.773 20.257a1.198 1.198 0 101.694 1.694L22.184 3.23a1.197 1.197 0 000-1.694zM3.723 15.934l3.066-3.066a5.073 5.073 0 01-.135-1.124c0-2.85 2.384-5.162 5.325-5.162.342 0 .675.039 1 .099l1.441-1.44a15.134 15.134 0 00-2.441-.204C4.121 5.036 0 10.823 0 11.744c0 .507 1.266 2.504 3.723 4.189zm16.515-8.376l-3.069 3.066c.082.362.133.734.133 1.12 0 2.85-2.383 5.159-5.323 5.159a5.51 5.51 0 01-.994-.097l-1.442 1.441c.769.125 1.577.204 2.436.204 7.857 0 11.978-5.789 11.978-6.707 0-.508-1.265-2.504-3.719-4.186z" />
  </Svg>
))
SvgEyeWithLine.isIcon = true
export default SvgEyeWithLine
